import { useEffect, useState } from 'react';
import { useGetEmployeePlantEngineersQuery } from '@Store/api/userApiSlice';

import { Option } from '@Components/types/options';
import { Flex, Typography } from 'antd';
import { MSelect } from '@Components/Base';

import styles from './fields-styles.module.css';

interface PlantEngineerFieldsProps {
  setValues: React.Dispatch<
    React.SetStateAction<{
      plantEngineer: string;
    }>
  >;
}

const PlantEngineerFields: React.FC<PlantEngineerFieldsProps> = ({
  setValues,
}) => {
  const { data } = useGetEmployeePlantEngineersQuery();
  const [userOptions, setUserOptions] = useState<Array<Option>>([]);

  useEffect(() => {
    if (data) {
      const transformedUsers = data.map((user) => ({
        label: `${user.empName} | ${user.empNumber}`,
        value: String(user.userId),
      }));

      setUserOptions(transformedUsers);
    }
  }, [data]);

  return (
    <div className={styles.container}>
      <Flex vertical gap={16}>
        <div>
          <Typography.Text>
            Please choose the respective Plant Engineer:
          </Typography.Text>
          <MSelect
            className={styles.purchaseOfficerSelect}
            options={userOptions}
            onChange={(value) => {
              setValues((prev) => {
                return { ...prev, plantEngineer: value };
              });
            }}
            placeholder="Choose Plant Engineer"
          />
        </div>
      </Flex>
    </div>
  );
};

export default PlantEngineerFields;
